import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '../shared/services/app.service';

@Pipe({
    name: 'BPcurrency',
    standalone: false
})
export class CurrencyPipe implements PipeTransform {
  constructor(private appService: AppService) { }

  transform(facility_id: any): String {
    return (this.appService.getCurrency(facility_id) == "") ? "INR" : this.appService.getCurrency(facility_id);//facility id is not needed here because currency is moved to account level;
  }

}
